// extracted by mini-css-extract-plugin
export default {"mainHeader":"FinancialAccounts_mainHeader__uc20h","sectionTitle":"FinancialAccounts_sectionTitle__bjUyH"};